import type { IconData } from '@stacksjs/iconify-core'

export const chevronCircleDownLeftF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 11V6a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2zm1 9C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronCircleDownLeftF
